var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"ml-2",attrs:{"color":_vm.color,"small":"","text-color":"white"},domProps:{"textContent":_vm._s(_vm.stateText)}})}
var staticRenderFns = []

export { render, staticRenderFns }